import { request } from '@vtx/utils';
import { useEffect } from 'react';
import { useState } from 'react';

export const getGasEnum = async (className, urlHead) => {
    const res = await request.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/common/enumList`, {
        body: {
            className,
        },
    });
    let list = [];
    if (res?.result === 0) {
        list = res.data;
    }
    return list;
};

export default (className, urlHead) => {
    const [enumList, setEnumList] = useState([]);
    useEffect(() => {
        getGasEnum(className, urlHead).then(data => {
            setEnumList(data);
        });
    }, []);
    return {
        enumList,
    };
};
